import React from 'react';
import styles from './Header.module.css';

function Header({ title }) {
  return (
    <header className={styles.header}>
      <h3>{title}</h3>
    </header>
  );
}

export default Header;
